import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const showAddUserModal = () => ({type: Modal.toggleModalConstant(Constants.ADD_USER)})

export interface EditUserAction extends Redux.Action {
  user: Types.User,
}
export const editModal = (user: Types.User): EditUserAction =>
  ({type: Constants.EDIT_USER, user})

export const updateAddUserModalField = (field: Modal.ModalField) =>
  ({type: Modal.updateModalConstant(Constants.ADD_USER), field})

export const createUser: Modal.Submit<Types.ModalData> = (communityIdentifier: string, payload: Types.ModalData) =>
  Request.requestActionCreator(Constants.ADD_USER)({
    method: 'POST',
    payload: {...payload, user_invite: true},
    url: `${Constants.SERVER_RESOURCE}/${payload.communityIdentifier || communityIdentifier}`,
  })

export const editUser: Modal.Submit<Types.ModalData> = (communityIdentifier: string, payload: Types.ModalData) =>
  Request.requestActionCreator(Constants.EDIT_USER)({
    method: 'PUT',
    payload,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}/edit/${payload.icp_guid}`,
  })

export type FetchUsers = Request.Request
export const fetchUsers: FetchUsers = (selectedCommunity: string) =>
  Request.requestActionCreator(Constants.FETCH_USERS)({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/${selectedCommunity}`,
  })

export const fetchAllUsers: FetchUsers = () =>
  Request.requestActionCreator(Constants.FETCH_USERS)({
    method: 'GET',
    url: Constants.SERVER_RESOURCE,
  })

export const resetConfirmAction = () => confirm('Are you sure?')

export type UpdateUser = (communityIdentifier: string, username: string, payload: any) => Request.RequestAction
export const updateUser: UpdateUser = (communityIdentifier: string, username: string, payload: any) =>
  Request.requestActionCreator(Constants.UPDATE_USER)({
    method: 'PUT',
    payload,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}/${username}`,
  })

export const updateStatus: IsActive.UpdateStatusAction = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_USER)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${stateChange.props.dataItem.community_identifier}/${stateChange.id}`,
  })

export const createOrUpdate = (community: string, data: Types.ModalData) =>
  data.icp_guid ? editUser(community, data) : createUser(community, data)



// WEBPACK FOOTER //
// ./src/pages/users/actions.ts